<div class="main-cont flexColumnParent" *ngIf="{ finished: capturedImages.front } as obj">
  <div class="flexItem" *ngIf="
      isConsentSubmitted &&
      isInstructionsSubmitted &&
      !camera?.loaded &&
      !camera?.noCameraReason &&
      !obj.finished
    ">
    <app-loader variant="thankyou"></app-loader>
  </div>

  <div class="flexItem" *ngIf="
      isConsentSubmitted && isInstructionsSubmitted && camera?.noCameraReason
    ">
    <h2>{{ camera.noCameraReason }}</h2>
    <button mat-flat-button (click)="retryCamera()" [disabled]="isInitializing">
      {{ (isInitializing ? 'test.retrying' : 'test.retryCamera') | translate }}
    </button>
  </div>

  <div class="test-cont flexItemBiggest flexColumnParent" [class.live]="!obj.finished"
    [class.hidden]="!isConsentSubmitted || !isInstructionsSubmitted">
    <!-- Live layout = 3-row grid: guidance (bottom-aligned) / camera (centred,
         fixed) / escape hatch (top-aligned). The camera never jumps when the
         text wraps or the hatch appears. -->
    <div class="test-cont-inner flexItem" *ngIf="(camera?.loaded || camera?.error) && !obj.finished">
      <h2 class="error-text" [class.error]="camera.error?.type === 'error'"
        [class.counting]="camera.error?.type === 'countdown' || !camera.error">
        {{ camera.error?.text || ('test.lookForward' | translate) }}
      </h2>
    </div>

    <div class="video_cont_wrap flexItemBiggest" *ngIf="!obj.finished">
      <app-camera #camera [readyToStart]="isInstructionsSubmitted" [capturedImages]="capturedImages"
        (imageCaptured)="onImageCaptured()" *ngIf="isConsentSubmitted"></app-camera>

      <button mat-raised-button color="warn" *ngIf="isAdmin()" (click)="fakePicture()"
        style="position: absolute; top: 10px; right: 10px; z-index: 1000;">
        {{ 'miscUi.fakePictureDev' | translate }}
      </button>
    </div>

    <!-- Never-stuck escape hatch (state + handler on the camera component):
         appears after 15s of continuous red / 50s without a shot. -->
    <div class="hatch-row" *ngIf="!obj.finished">
      <div class="continue-anyway-wrap" *ngIf="camera?.showContinueAnyway">
        <p class="continue-warning">{{ camera.continueWarningKey | translate }}</p>
        <button type="button" class="continue-anyway-button" (click)="camera.continueAnyway()">
          {{ 'cameraErrors.continueAnyway' | translate }}
        </button>
      </div>
    </div>

    <!-- The shot, shown back for Retake / Proceed. The preview reads the blob
         we already built for the upload (an object URL), so showing it costs
         nothing beyond the capture itself. -->
    <div class="thumbnails flexItemBiggest flexRowParent" *ngIf="obj.finished">
      <div class="flexItemBiggest image-container">
        <img class="image" [src]="previewUrl" [class.visibilityHidden]="!previewUrl" />
        <div class="lottie-overlay" *ngIf="isSending || sendFailed">
          <app-loader variant="analyzing" [compact]="true" [hideCenterIcon]="true"
            [failed]="sendFailed" [failedMessage]="error || ''" (retry)="sendToServer()"></app-loader>
        </div>
      </div>
    </div>

    <!-- The overlay loader owns the failure (message + Retry) while sendFailed
         is set, so the message is never shown twice. -->
    <div class="error-container" *ngIf="error && obj.finished && !sendFailed">
      <div class="error-content">
        <p class="error-message">{{ error }}</p>
        <button mat-button color="primary" (click)="clearError()">
          {{ 'test.dismiss' | translate }}
        </button>
      </div>
    </div>

    <div class="flexItem btn-insight" *ngIf="obj.finished">
      <button mat-button (click)="removeImage('front')" [disabled]="isSending">
        {{ 'test.retake' | translate }}
      </button>
      <button mat-button mat-raised-button (click)="sendToServer()" [disabled]="isSending || error">
        {{ (isSending ? 'test.analyzing' : 'test.proceed') | translate }}
      </button>
    </div>
  </div>
</div>